import environModel from 'data/environment_sidebar.json';
import environLegend from 'data/environment-legend.json';
import { getHandlerFor } from 'client/utils/angular';

export default function ($scope, Maps, $window, $rootScope, sidebarService) {
  $scope.environSidebar = Object.assign({}, environModel);

  if ($scope.legendTitle != "environment")
    $rootScope.$broadcast('map/setlegend', [environLegend, "environment"]);//Set legend to environment

  //Tooltips for question marks in sidebar
  $scope.tooltip_wetland = {title: 'Click question mark for source', checked: true};
  $scope.tooltip_wooded = {title: 'Click question mark for source', checked: true};
  $scope.tooltip_regional = {title: 'Click question mark for source', checked: true};
  $scope.tooltip_ansi = {title: 'Click question mark for source', checked: true};

   const update = ({ wetlands, woodedarea: woodedArea, regionalforest: regionalForest, ansi
                      }) => {
    //Check if there is Wetlands Information
    if ('no_result' in wetlands) {
      //There is no wetlands
      $scope.wetlandsOn = false;

      $scope.environSidebar.wetlandsValue = "No";

      $scope.environSidebar.wetlandInfo.error = wetlands.no_result;
    } else if ('error' in wetlands) {
      //There is no wetlands
      $scope.wetlandsOn = false;

      //Set error message for user
      $scope.environSidebar.wetlandsValue = wetlands.error;

      $scope.environSidebar.wetlandInfo.error = wetlands.error;
    } else {
      //There is wetlands
      $scope.wetlandsOn = true;

      $scope.environSidebar.wetlandsValue = "Yes";

      $scope.environSidebar.wetlandInfo = wetlands;
    }

    //Check if there is Woodlands Information
    if ('no_result' in woodedArea) {
      //There is not wooded
      $scope.woodedOn = false;

      $scope.environSidebar.woodlandsValue = "No";

      $scope.environSidebar.woodedInfo.error = woodedArea.no_result;
    } else if ('error' in woodedArea) {
      //There is not wooded
      $scope.woodedOn = false;

      //Set error message for user
      $scope.environSidebar.woodlandsValue = woodedArea.error;

      $scope.environSidebar.woodedInfo.error = woodedArea.error;
    } else{
      //There is wooded
      $scope.woodedOn = true;

      $scope.environSidebar.woodlandsValue = "Yes";

      $scope.environSidebar.woodedInfo = woodedArea;
    }

    //Check if there is Regional Forest Information
    if ('no_result' in regionalForest) {
      //There is not regional forest
      $scope.regional_forestOn = false;

      $scope.environSidebar.regionalForestValue = "No";

      $scope.environSidebar.regional_forestInfo.error = regionalForest.no_result;
    } else if ('error' in regionalForest) {
      //There is not regional forest
      $scope.regional_forestOn = false;

      $scope.environSidebar.regionalForestValue = regionalForest.error;

      $scope.environSidebar.regional_forestInfo.error = regionalForest.error;
    } else {
      //There is regional forest
      $scope.regional_forestOn = true;

      $scope.environSidebar.regionalForestValue = "Yes";

      $scope.environSidebar.regional_forestInfo = regionalForest;
    }

    //Check if there is ANSI Information
    if ('no_result' in ansi) {
      //There is not ansi
      $scope.ansiOn = false;

      $scope.environSidebar.ansiInfo.error = ansi.no_result;
    } else if ('error' in ansi) {
      //There is not ansi
      $scope.ansiOn = false;

      $scope.environSidebar.ansiInfo.error = ansi.error;
    } else {
      //There is ansi
      $scope.ansiOn = true;

      $scope.environSidebar.ansiInfo = ansi;
    }

  };if(!$scope.isSearchBar) {
    //reset wetland on/off button if needed.
    $scope.environSidebar.wetland[0].toggle = $scope.checkLayer($scope.environSidebar.wetland[0].name);

    //reset wooded on/off button if needed.
    $scope.environSidebar.wooded[0].toggle = $scope.checkLayer($scope.environSidebar.wooded[0].name);

    //reset regional forest on/off button if needed.
    $scope.environSidebar.regional_forest[0].toggle = $scope.checkLayer($scope.environSidebar.regional_forest[0].name);

    //reset ansi on/off button if needed.
    $scope.environSidebar.ansi[0].toggle = $scope.checkLayer($scope.environSidebar.ansi[0].name);

       if(!$scope.onSidebar){
           sidebarService.sidebarInfo({
        type: "environment_sidebar",
        gid: $scope.sidebar.gid,
        myp_municipality: $scope.sidebar.myp_municipality
      }).success(update);
    }}

  //Turn off the dev app if it's turned on
  if ($rootScope.isDev) {
    $rootScope.$broadcast('map/setinfocontent', [$rootScope.address, 'address']);
    $rootScope.$broadcast('map/openaddresswindow');
    $rootScope.isDev = false;
    $rootScope.$broadcast('locationToggle');
  }

  $scope.environTab = function (url) {
    $window.open(url, '_blank');
  };

  $scope.wetlandsOn = false;
  $scope.woodedOn = false;
  $scope.regional_forestOn = false;
  $scope.ansiOn = false;

  $scope.wetTog = false;
  $scope.woodTog = false;
  $scope.regTog = false;
  $scope.ansiTog = false;

  const toggle = (status) => {
    $scope.environSidebar.wetland[0].toggle = status;
    $scope.environSidebar.wooded[0].toggle = status;
    $scope.environSidebar.regional_forest[0].toggle = status;
    $scope.environSidebar.ansi[0].toggle = status;
  };

  const reset = () => {
    $scope.environSidebar = Object.assign({}, environModel);
    $scope.wetlandsOn = false;
    $scope.woodedOn = false;
    $scope.regional_forestOn = false;
    $scope.ansiOn = false;
  };

  $rootScope.$on('sidebar/environ/update', getHandlerFor(update));
  $rootScope.$on('sidebar/environ/toggle', getHandlerFor(toggle));
  $rootScope.$on('sidebar/environ/reset', getHandlerFor(reset));

  return {
    update,
    toggle,
    reset
  };
};



// WEBPACK FOOTER //
// ./client/controllers/environment_sidebar.js